import CompetitiveSpots from "./CompetitiveSpots";

export default CompetitiveSpots;
